/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddNotificationCommand } from '../models/AddNotificationCommand';
import type { CommandSuccessViewModel } from '../models/CommandSuccessViewModel';
import type { CommandSuccessWithIdViewModel } from '../models/CommandSuccessWithIdViewModel';
import type { DeleteNotificationCommand } from '../models/DeleteNotificationCommand';
import type { GetFirebasePushCampaignStatsForAdminQuery } from '../models/GetFirebasePushCampaignStatsForAdminQuery';
import type { GetNotificationDeliveryConversionForAdminQuery } from '../models/GetNotificationDeliveryConversionForAdminQuery';
import type { GetNotificationQuery } from '../models/GetNotificationQuery';
import type { GetPushCampaignPartnerImpactForAdminQuery } from '../models/GetPushCampaignPartnerImpactForAdminQuery';
import type { GetPushNotificationStatisticsForAdminQuery } from '../models/GetPushNotificationStatisticsForAdminQuery';
import type { ListNotificationDeliveryHistoryQuery } from '../models/ListNotificationDeliveryHistoryQuery';
import type { ListNotificationsQuery } from '../models/ListNotificationsQuery';
import type { NotificationBasicViewModelPaginatedListViewModel } from '../models/NotificationBasicViewModelPaginatedListViewModel';
import type { NotificationDeliveryConversionViewModel } from '../models/NotificationDeliveryConversionViewModel';
import type { NotificationDeliveryHistoryViewModelPaginatedListViewModel } from '../models/NotificationDeliveryHistoryViewModelPaginatedListViewModel';
import type { NotificationDetailedViewModel } from '../models/NotificationDetailedViewModel';
import type { PushCampaignPartnerImpactViewModel } from '../models/PushCampaignPartnerImpactViewModel';
import type { PushCampaignStatsViewModel } from '../models/PushCampaignStatsViewModel';
import type { PushNotificationStatsViewModel } from '../models/PushNotificationStatsViewModel';
import type { SendCustomNotificationCommand } from '../models/SendCustomNotificationCommand';
import type { SendNotificationCommand } from '../models/SendNotificationCommand';
import type { UpdateNotificationCommand } from '../models/UpdateNotificationCommand';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class NotificationService {
    /**
     * Create notification and get it's id
     * @param requestBody
     * @returns CommandSuccessWithIdViewModel Success
     * @throws ApiError
     */
    public static postApiNotificationAddNotification(
        requestBody?: AddNotificationCommand,
    ): CancelablePromise<CommandSuccessWithIdViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/notification/add-notification',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Delete notification by id
     * @param requestBody
     * @returns CommandSuccessViewModel Success
     * @throws ApiError
     */
    public static postApiNotificationDeleteNotification(
        requestBody?: DeleteNotificationCommand,
    ): CancelablePromise<CommandSuccessViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/notification/delete-notification',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Schedule notification to be sent
     * @param requestBody
     * @returns CommandSuccessViewModel Success
     * @throws ApiError
     */
    public static postApiNotificationSendNotification(
        requestBody?: SendNotificationCommand,
    ): CancelablePromise<CommandSuccessViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/notification/send-notification',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Update notification details
     * @param requestBody
     * @returns CommandSuccessViewModel Success
     * @throws ApiError
     */
    public static postApiNotificationUpdateNotification(
        requestBody?: UpdateNotificationCommand,
    ): CancelablePromise<CommandSuccessViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/notification/update-notification',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * List notifications with base details
     * @param requestBody
     * @returns NotificationBasicViewModelPaginatedListViewModel Success
     * @throws ApiError
     */
    public static postApiNotificationListNotifications(
        requestBody?: ListNotificationsQuery,
    ): CancelablePromise<NotificationBasicViewModelPaginatedListViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/notification/list-notifications',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Update notification details
     * @param requestBody
     * @returns NotificationDetailedViewModel Success
     * @throws ApiError
     */
    public static postApiNotificationGetNotification(
        requestBody?: GetNotificationQuery,
    ): CancelablePromise<NotificationDetailedViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/notification/get-notification',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * List notification delivery history
     * @param requestBody
     * @returns NotificationDeliveryHistoryViewModelPaginatedListViewModel Success
     * @throws ApiError
     */
    public static postApiNotificationListNotificationDeliveryHistory(
        requestBody?: ListNotificationDeliveryHistoryQuery,
    ): CancelablePromise<NotificationDeliveryHistoryViewModelPaginatedListViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/notification/list-notification-delivery-history',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Get how many recipients of a delivery purchased after the send (correlation, not attribution)
     * @param requestBody
     * @returns NotificationDeliveryConversionViewModel Success
     * @throws ApiError
     */
    public static postApiNotificationGetNotificationDeliveryConversionForAdmin(
        requestBody?: GetNotificationDeliveryConversionForAdminQuery,
    ): CancelablePromise<NotificationDeliveryConversionViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/notification/get-notification-delivery-conversion-for-admin',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Send a custom notification to specific users
     * @param requestBody
     * @returns CommandSuccessViewModel Success
     * @throws ApiError
     */
    public static postApiNotificationSendCustomNotification(
        requestBody?: SendCustomNotificationCommand,
    ): CancelablePromise<CommandSuccessViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/notification/send-custom-notification',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Get push notification open statistics from GA4
     * @param requestBody
     * @returns PushNotificationStatsViewModel Success
     * @throws ApiError
     */
    public static postApiNotificationGetPushNotificationStatsForAdmin(
        requestBody?: GetPushNotificationStatisticsForAdminQuery,
    ): CancelablePromise<PushNotificationStatsViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/notification/get-push-notification-stats-for-admin',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Get per-campaign Firebase push engagement stats (synced nightly from the BigQuery export)
     * @param requestBody
     * @returns PushCampaignStatsViewModel Success
     * @throws ApiError
     */
    public static postApiNotificationGetFirebasePushCampaignStatsForAdmin(
        requestBody?: GetFirebasePushCampaignStatsForAdminQuery,
    ): CancelablePromise<PushCampaignStatsViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/notification/get-firebase-push-campaign-stats-for-admin',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Get sales for each campaign's promoted partner in the 96 hours after it was sent
     * @param requestBody
     * @returns PushCampaignPartnerImpactViewModel Success
     * @throws ApiError
     */
    public static postApiNotificationGetPushCampaignPartnerImpactForAdmin(
        requestBody?: GetPushCampaignPartnerImpactForAdminQuery,
    ): CancelablePromise<PushCampaignPartnerImpactViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/notification/get-push-campaign-partner-impact-for-admin',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
}
